import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { DEFAULT_THEME_COLOR } from '../../constants/theme';
import { foldLocked } from '../../utils/theFreaks';
import useFreaksT from './useFreaksT';
import { STAT_ICONS } from './statIcons';
import { freaksSx as s, tonalSx } from './freaksStyles';

// Real kit for the activity; each piece adds to one stat while you play this activity.
// Better tiers unlock at higher freak levels; locked ones after the next are folded away.
export default function FreaksGearList({ gear, cash, disabled, onBuy }) {
  const { t } = useFreaksT();
  const [showLocked, setShowLocked] = useState(false);
  const { visible, hidden } = foldLocked(gear);
  return (
    <Box data-testid="freaks-gear">
      {(showLocked ? gear : visible).map((item) => {
        const Icon = STAT_ICONS[item.stat] ?? STAT_ICONS.charisma;
        return (
          <Box key={item.key} sx={{ ...s.card, ...s.between, opacity: item.locked && !item.owned ? 0.55 : 1 }}>
            <Icon sx={{ fontSize: 28, color: item.owned ? DEFAULT_THEME_COLOR : '#888' }}/>
            <Box sx={s.grow}>
              <Typography sx={s.title}>{item.name}</Typography>
              <Typography sx={s.small}>
                {t('theFreaks.gear.bonus', { bonus: item.bonus, stat: t(`theFreaks.stats.${item.stat}`) })}
              </Typography>
            </Box>
            {item.owned ? (
              <Typography sx={{ ...s.bold, color: DEFAULT_THEME_COLOR, flexShrink: 0 }}>✓ {t('theFreaks.gear.owned')}</Typography>
            ) : item.locked ? (
              <Typography sx={{ ...s.small, ...s.muted, maxWidth: 120, textAlign: 'right' }} data-testid={`freaks-gear-locked-${item.key}`}>
                🔒 {t('theFreaks.gear.locked', { level: item.unlockLevel })}
              </Typography>
            ) : (
              <Button
                data-testid={`freaks-gear-${item.key}`}
                disabled={disabled || cash < item.price}
                onClick={() => onBuy(item)}
                sx={tonalSx}
              >
                {t('theFreaks.gear.buy', { price: item.price })}
              </Button>
            )}
          </Box>
        );
      })}
      {hidden ? (
        <Button
          data-testid="freaks-gear-locked-toggle"
          onClick={() => setShowLocked(!showLocked)}
          sx={{ textTransform: 'none', fontWeight: 700, color: DEFAULT_THEME_COLOR }}
        >
          {showLocked ? t('theFreaks.gear.hideLocked') : t('theFreaks.gear.showLocked', { count: hidden })}
        </Button>
      ) : null}
    </Box>
  );
}
